import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import { Button, Paper, Stack, Typography } from "@mui/material";
import ClassificationBullets from "./ClassificationBullets";
import { accessCheckButtonSx } from "./styles";
import type { BucketClassification } from "./types";

interface Props {
  classification: BucketClassification;
  onDownload: () => void;
}

const AccessCheckResults = ({ classification, onDownload }: Props) => {
  return (
    <Paper variant="outlined" sx={{ width: "100%", bgcolor: "background.grey", p: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1">Results</Typography>
        {classification.conclusion && <Typography variant="subtitle1">{classification.conclusion}</Typography>}
        <Typography color="textSecondary">{classification.suggestion}</Typography>

        <ClassificationBullets bullets={classification.bullets} />

        <Typography color="textSecondary">
          You can download a file with the technical details of this check and send it to support.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<SaveAltRoundedIcon />}
          onClick={onDownload}
          fullWidth
          sx={accessCheckButtonSx}
        >
          Download File
        </Button>
      </Stack>
    </Paper>
  );
};

export default AccessCheckResults;
